<script setup lang="ts">
export interface StoryblokWhatsappLinkProps {
    blok: StoryblokWhatsappLink;
}

// PROPS
const { blok } = defineProps<StoryblokWhatsappLinkProps>();
</script>

<template>
    <FleequidWhatsappLink v-editable="blok" :color="blok.color" />
</template>
